import type { FunctionComponent } from 'react'
import { Button } from './Button'
import { Hidden } from './Hidden'
import style from './Title.module.sass'

type TitleProps = {
	title: string | JSX.Element
	value?: number
	hasButton?: boolean
	buttonUrl?: string
	buttonLabel?: string
	buttonOnClick?: () => void
	disabled?: boolean
}

export const Title: FunctionComponent<TitleProps> = ({
	title,
	value,
	hasButton = false,
	buttonLabel,
	buttonUrl,
	buttonOnClick,
	disabled = false,
}) => {
	return (
		<div className={style.wrapper}>
			<h2 className={style.title}>
				{title} {value && <span className={style.value}>{value}</span>}
			</h2>
			{hasButton && (
				<Hidden breakpoint="mobileDown">
					<Button
						type={{ variant: 'underlinedGrey' }}
						label={buttonLabel}
						url={buttonUrl}
						disabled={disabled}
						onClick={buttonOnClick}
					/>
				</Hidden>
			)}
		</div>
	)
}
